<template>
  <DynamicallyPaginated @reload="reload" :row-height="64" :item-count="all.item_count">
    <template #header>
      <SearchBar v-model="searchFilter" debounce />
    </template>

    <v-list two-line class="py-0 rounded-lg" style="overflow-y: auto;">
      <template v-for="(request, index) in filtered">
        <v-divider v-if="index > 0" :key="`divider-${ index }`" />

        <LeadItem :request="request" :key="`item-${ index }`" @drill-down="r => $emit('drill-down', r)" />  
      </template>
    </v-list>
  </DynamicallyPaginated>
</template>

<script>
import { DynamicallyPaginated } from '@/components/pages'
import LeadItem from './LeadItem'
import SearchBar from '@/components/SearchBar.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'LeadList',

  components: { DynamicallyPaginated, LeadItem, SearchBar },

  data() {
    return {
      searchFilter: '',

      rowCount: 0,
      
      lastOffset: -1,
      maxLimit: -1,
    }
  },
  
  computed: {
    ...mapGetters('customer_requests', ['all']),

    filtered() {
      return this.rowCount ? this.all.data.slice(0, this.rowCount) : []
    }
  },

  watch: {
    searchFilter() {
      this.reload({
        limit: this.rowCount,
        offset: 0,
        force: true
      })
    },
  },
  
  methods: {
    ...mapActions('customer_requests', ['loadAll']),

    reload({ limit, offset, force }) {
      const { searchFilter: search } = this
      this.rowCount = limit

      if (force || this.lastOffset != offset || limit > this.maxLimit) {
        this.maxLimit = limit
        // this.maxLimit = Math.max(this.maxLimit, limit )

        this.lastOffset = offset

        this.loadAll({ limit: this.maxLimit, offset, search })
      }
    }
  },

  async created() {
    this.reload({limit: 20, offset: 0})
  },
}

</script>